import {
  Component,
  ViewEncapsulation,
  OnInit,
  TemplateRef,
  ViewChild,
  Input,
  ChangeDetectorRef,
  HostListener,
  AfterViewInit,
} from '@angular/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { Page } from 'src/app/ui/datatable/page';
import { PaginationObject } from 'src/app/models/paginationObject';
import { SortObject } from 'src/app/models/sortObject';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { ExportToCsv } from 'export-to-csv';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { StringToDate } from 'src/app/utils/stringToDate';
import { OrdersService } from 'src/app/user/dashboard/orders/service/orders.service';
import { NavigationService } from 'src/app/app-layout/navigation/service/navigation.service';
import sortHelper from 'src/app/helpers/sort';
import { BudgetsService } from 'src/app/user/dashboard/budgets/service/budgets.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [OrdersService, BudgetsService],
})
export class DatatableGenericComponent implements OnInit, AfterViewInit {
  @ViewChild('table', { static: false }) table: DatatableComponent;
  @ViewChild('plainCell', { static: true }) plainCell: TemplateRef<any>;
  @ViewChild('dayHourFormat', { static: true }) dayHourFormat: TemplateRef<any>;
  @ViewChild('personNameCell', { static: true }) personNameCell: TemplateRef<any>;
  @ViewChild('checkboxCell', { static: true }) checkboxCell: TemplateRef<any>;
  @ViewChild('dateCell', { static: true }) dateCell: TemplateRef<any>;
  @ViewChild('translateCell', { static: true }) translateCell: TemplateRef<any>;
  @ViewChild('percentageCell', { static: true }) percentageCell: TemplateRef<any>;
  @ViewChild('currencyCell', { static: true }) currencyCell: TemplateRef<any>;
  @ViewChild('timeCell', { static: true }) timeCell: TemplateRef<any>;
  @ViewChild('navigationIcon', { static: true }) navigationIcon: TemplateRef<any>;
  @ViewChild('navigationAndJiraIcon', { static: true }) navigationAndJiraIcon: TemplateRef<any>;
  @ViewChild('jiraIcon', { static: true }) jiraIcon: TemplateRef<any>;
  @ViewChild('errorDetails', { static: true }) errorDetails: TemplateRef<any>;

  @Input() public service: Function;
  @Input() public deleteService: Function;
  @Input() public defaultColumns: [];
  @Input() public section: string;
  @Input() public subsection: string;
  @Input() public subsectionRoute: string = null;
  @Input() public enableFilter: boolean = true;
  @Input() public columnsToExclude: string[] = [];
  @Input() public isMultiForm: boolean = false;

  page = new Page();
  rows = new Array<any>();
  temp = [];
  columns = [];
  selectedTableColumns = [];
  columnsToDisplayInDropdown = [];
  data = {};

  rawEvent: any;
  contextmenuRow: any;
  contextmenuColumn: any;

  ColumnMode = ColumnMode;
  paginationObject = new PaginationObject();
  queryString = '';
  schema: any;
  selectedRows = [];
  checkAll: boolean = false;

  @Input() sortArray: SortObject[];

  csvOptions: any = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: false,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
  };
  csvExporter = new ExportToCsv(this.csvOptions);
  columnsExist = false;
  showSearch = false;
  searchColumnUpdate = new Subject<any>();
  tableData = null;
  booleanValues = [
    { value: null, name: 'All' },
    { value: 'true', name: 'True' },
    { value: 'false', name: 'False' },
  ];
  @HostListener('click', ['$event']) onClick(e) {
    if (this.showSearch && this.selectedTableColumns.find((el) => el.name == e.target.id)) {
      var columnValue = e.target.innerText;
      var columnName = e.target.id;
      if (this.schema && this.schema[columnName] == 'percentage') {
        columnValue = columnValue.split(' ')[0];
      }
      if (this.schema && this.schema[columnName] == 'date') {
        if (columnValue !== '') {
          columnValue = columnValue.split(' ')[0];
          columnValue = columnValue.replaceAll('/', '-');
          let temp = columnValue.split('-');
          columnValue = temp[2] + '-' + temp[1] + '-' + temp[0];
        }
      }
      if (this.schema && this.schema[columnName] == 'currency') {
        columnValue = columnValue.split(' ')[0];
      }
      this.search(columnValue, columnName);
    }
  }

  constructor(
    public http: HttpClient,
    public translate: TranslateService,
    public route: ActivatedRoute,
    public cdr: ChangeDetectorRef,
    public ordersDashboardService: OrdersService,
    public budgetsDashboardService: BudgetsService,
    public toastService: ToastService,
    public navigationService: NavigationService,
    public router: Router
  ) {
    this.searchColumnUpdate.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((input) => {
      this.search(input.value ? input.value.toString() : '', input.id);
    });
    if (window.location.pathname.includes('/dashboard/orders')) {
      this.ordersDashboardService.ordersDashboardData.subscribe(async (fetch) => {
        if (this.service) {
          await this.fetchData({
            paginationObject: this.paginationObject,
            sortArray: this.sortArray,
            query: this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '',
          });
          this.columns = [...this.columns];
          if (this.defaultColumns.length > 0) {
            this.selectTableColumns(this.defaultColumns);
          }
        }
      });
    }
    if (window.location.pathname.includes('/dashboard/budgets')) {
      this.budgetsDashboardService.budgetsDashboardData.subscribe(async (fetch) => {
        if (this.service) {
          await this.fetchData({
            paginationObject: this.paginationObject,
            sortArray: this.sortArray,
            query: this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '',
          });
          this.columns = [...this.columns];
          if (this.defaultColumns.length > 0) {
            this.selectTableColumns(this.defaultColumns);
          }
        }
      });
    }
  }

  convertStringToDate(strDate: string) {
    return StringToDate(strDate);
  }

  generateTable(data) {
    this.selectedRows = [];
    this.columns = [];
    this.tableData = data.data;
    this.schema = data.schema;
    if (this.tableData.content.length > 0) {
      Object.keys(this.tableData.content[0]).forEach((key, index) => {
        this.columns.push({
          name: key,
          prop: key,
          cellTemplate: this.pickCellTemplate(this.schema[key], key),
          headerTemplate: this.translateCell,
          selected: false,
          width: 130,
        });
      });
      this.columns.push({
        name: 'Navigation',
        prop: 'Navigation',
        cellTemplate: this.checkNavigation(),
        sortable: false,
        selected: false,
        width: 120,
      });
    }

    this.rows = this.tableData.content;

    this.page = {
      size: this.tableData.size,
      totalElements: this.tableData.totalElements,
      totalPages: this.tableData.totalPages,
      pageNumber: this.tableData.number,
    };

    const columnsToBeExcluded = [
      'Navigation',
      'identificationCodeMnemonic',
      'personaName',
      'personaIdentifier',
      ...this.columnsToExclude,
    ];

    var savedColumns = localStorage.getItem(this.section + '-default-columns')
      ? JSON.parse(localStorage.getItem(this.section + '-default-columns'))
      : [];
    if (savedColumns.length) {
      this.defaultColumns = savedColumns;
    }

    if (this.columnsToDisplayInDropdown?.length == 0 && this.columns.length > 0) {
      var defaultCheckedColumns = this.defaultColumns
        .map((elem: any) => {
          const baseColumn = this.columns.find((c: any) => c.name === elem.name);
          if (baseColumn) {
            baseColumn.selected = true;
            return baseColumn;
          } else return { name: null };
        })
        .filter((col: any) => !columnsToBeExcluded.find((c) => col.name === c));

      const extraColumns = this.columns.filter(
        (column) => !columnsToBeExcluded.concat(defaultCheckedColumns.map((c) => c.name)).find((c) => column.name === c)
      );
      this.columnsToDisplayInDropdown = defaultCheckedColumns.concat(extraColumns);
    }
  }

  async ngOnInit() {
    var query = '';
    if (window.location.search.includes('?query')) {
      query = '&' + window.location.search.split('?')[1];
    }
    if (window.location.search.includes('sort')) {
      let sortString = window.location.search.split('sort=')[1];
      if (sortString.includes('&')) {
        sortString = sortString.split('&')[0];
      }
      this.sortArray = [];
      this.sortArray.push({ prop: sortString.split(',')[0], dir: sortString.split(',')[1] });
    }
    let defaultSort = localStorage.getItem(this.section + '-default-sort');
    if (defaultSort) {
      this.sortArray = JSON.parse(defaultSort);
    }
    await this.fetchData({ paginationObject: new PaginationObject(), sortArray: this.sortArray, query: query });
    this.columns = [...this.columns];
    if (this.defaultColumns.length > 0) {
      this.selectTableColumns(this.defaultColumns);
    }
    /* we need to parse values and fill in input boxes of the search */
    if (query.length > 0) {
      let fillValues = decodeURIComponent(query).split('&query=')[1].split(/[=&]+/);
      var valueIndex = 0;
      fillValues.forEach((q, i) => {
        if (valueIndex < fillValues.length) {
          this.selectedTableColumns.find((el) => el.name == fillValues[valueIndex]).searchValue =
            fillValues[valueIndex + 1];
          valueIndex = valueIndex + 2;
        }
      });
      this.queryString = decodeURIComponent(window.location.search.split('?query=')[1]);
    }
    /* fill inputs done */
  }

  async fetchData(data) {
    var result = await this.service(data.paginationObject, data.sortArray, data.query);
    if (this.section === 'errors') {
      this.navigationService.errorCountSource.next(result.data.totalElements);
    }
    this.generateTable(result);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // moving footer inside the body so it has box shadow as per design
      var footer = document.getElementsByClassName('datatable-footer')[0];
      var body = document.getElementsByClassName('datatable-body')[0];
      body.appendChild(footer);
    }, 10);
  }

  setPage(pageInfo) {
    this.paginationObject = pageInfo;
    this.columnsExist = true;
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    this.fetchData({ paginationObject: pageInfo, sortArray: this.sortArray, query: query });
  }

  onSort(event) {
    this.sortArray = event.sorts;
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    let sortQuery = sortHelper.constructSort(this.sortArray, true).split('sort=')[1];
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { sort: sortQuery },
      queryParamsHandling: 'merge',
    });
    localStorage.setItem(this.section + '-default-sort', JSON.stringify(this.sortArray));
    this.fetchData({ paginationObject: new PaginationObject(), sortArray: event.sorts, query: query });
  }

  selectTableColumns(event, addNewColumn?: boolean) {
    var columnsToBeExcluded = [
      'Navigation',
      'identificationCodeMnemonic',
      'personaName',
      'personaIdentifier',
      'checked',
      'jiraUrl',
      ...this.columnsToExclude,
    ];
    /* if removing column */
    var duplicate;
    event.forEach((x) => {
      var count = 0;
      event.forEach((y) => {
        if (x.name == y.name) {
          count++;
          if (count > 1) duplicate = x;
        }
      });
    });
    if (duplicate) {
      _.remove(event, {
        name: duplicate.name,
      });
      this.columns.forEach((element) => {
        if (element.name == duplicate.name) {
          element.selected = false;
        }
      });
      this.removeFromSort(duplicate.name);
      this.removeFromQuery(duplicate.name);
    }
    /* removing colum end */

    /* order columns by default order from the backend */

    this.selectedTableColumns = [];
    this.columnsToDisplayInDropdown = this.columns;

    let sortedEventArray = this.columns.map((el) => {
      return event.find((eventEl) => eventEl.name === el.name);
    });
    sortedEventArray = sortedEventArray.filter((el) => el !== undefined);
    sortedEventArray = sortedEventArray.length == 0 ? event : sortedEventArray;

    if (this.section == 'order' || this.section == 'budget') {
      this.selectedTableColumns.push({
        name: 'identifier',
        prop: 'identifier',
        searchValue: '',
        cellTemplate: this.pickCellTemplate('string', 'identifier'),
        headerTemplate: this.translateCell,
        selected: false,
        width: 130,
      });
    }

    /* order columns by default order from the backend end*/
    sortedEventArray.forEach((el) => {
      this.columns.forEach((element) => {
        if (element.name == el.name) {
          element.selected = true;
        }
      });
      if (el.name !== 'Navigation' && !columnsToBeExcluded.find((e) => e === el.name)) {
        this.selectedTableColumns.push({
          name: el.name,
          prop: el.name,
          searchValue: el.searchValue,
          cellTemplate: this.pickCellTemplate(this.schema[el.name], el.name),
          headerTemplate: this.translateCell,
          selected: false,
          width: 130,
        });
      }
    });
    this.selectedTableColumns.push({
      name: 'Navigation',
      prop: 'Navigation',
      cellTemplate: this.checkNavigation(),
      sortable: false,
      selected: false,
      width: 120,
    });
    // remove fitler, custom id and persona name from dropdown

    this.columnsToDisplayInDropdown = this.columnsToDisplayInDropdown.filter(
      (column: any) => !columnsToBeExcluded.find((c) => column.name === c)
    );
    if (addNewColumn && !duplicate) {
      this.refreshData();
    }
    var selectedColumns = [];
    this.columns.forEach((column) => {
      if (this.selectedTableColumns.find((selectedColumn) => selectedColumn.name === column.name)) {
        selectedColumns.push({ name: column.name });
      }
    });
    localStorage.setItem(this.section + '-default-columns', JSON.stringify(selectedColumns));
  }

  selectAllColumns() {
    this.selectTableColumns(this.columns);
  }

  unselectAllColumns() {
    const columnsToKeep = this.columns.filter(
      (col) => col.name == 'identificationCodeMnemonic' || col.name == 'personaName'
    );

    this.selectedTableColumns.forEach((col) => {
      this.selectTableColumns([col, ...columnsToKeep]);
    });
    this.columns.forEach((col) => (col.selected = false));
  }

  async exportCSV() {
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';

    let result = await this.service({ pageSize: this.page.totalElements }, this.sortArray, query);
    var columns = this.selectedTableColumns;
    this.columnsToExclude.forEach((columnToExclude) => {
      columns = columns.filter((el) => el.name !== columnToExclude);
    });

    var dataToExport = result.data;

    var data = dataToExport.content;

    // we want export only data that is shown in the selected columns
    const dataForExport = data.map((o) =>
      columns.reduce((acc, curr) => {
        if (curr.name !== 'Navigation') {
          let translatedColumnName: any = this.translate.instant('columnName.' + curr.name);
          acc[translatedColumnName] = o[curr.name] ? o[curr.name] : '';
        }
        return acc;
      }, {})
    );

    let subsection = this.subsection ? (this.section ? '_' : '') + this.subsection : '';
    let section = this.section ? this.section : '';

    this.csvExporter.options.filename = section + subsection + '-' + moment().toISOString();

    this.csvExporter.generateCsv(dataForExport);
  }

  displaySearch() {
    this.showSearch = !this.showSearch;
    var cells: any = document.getElementsByTagName('datatable-header-cell');
    for (let i = 0; i < cells.length; i++) {
      if (this.showSearch) {
        cells[i].classList.add('datatable-header-cell-search');
      } else {
        cells[i].classList.remove('datatable-header-cell-search');
      }
    }
  }

  async search(columnValue, columnName) {
    var searchValue = columnValue;
    var searchName = columnName;
    if (this.schema && this.schema[columnName] == 'percentage' && columnValue.length > 0) {
      if (columnValue.includes('%')) {
        columnValue = columnValue.slice(0, -1);
      }
      columnValue = columnValue.split(',').join('.');
      searchValue = Number(columnValue / 100).toFixed(4);
    }
    if (this.schema && this.schema[columnName] == 'currency' && columnValue.length > 0) {
      let tempCalc = columnValue;
      let thousands = parseFloat(columnValue.split(' ')[0].split(',')[0].replace('.', ''));
      let decimals = parseFloat(columnValue.split(' ')[0].split(',')[1]);
      let decimalNumber = thousands.toString();
      if (decimals > 0) {
        decimalNumber = thousands + '.' + decimals;
      }
      searchValue = decimalNumber.replace(',', '');
      columnValue = tempCalc;
    }
    this.selectedTableColumns.find((el) => el.name == searchName).searchValue = columnValue;
    var newQuery = searchName + '=' + encodeURIComponent(searchValue);
    if (searchValue.trim().length == 0) {
      this.removeFromQuery(searchName);
      return;
    }
    if (this.queryString.includes(searchName)) {
      var queries = this.queryString.split('=');
      var valueIndex;
      queries.forEach((q, i) => {
        if (q.includes(searchName)) {
          valueIndex = i + 1;
        }
      });
      if (queries[valueIndex].includes('&')) {
        let values = queries[valueIndex].split('&');
        values[0] = encodeURIComponent(searchValue);
        queries[valueIndex] = values.join('&');
      } else {
        queries[valueIndex] = encodeURIComponent(searchValue);
      }
      this.queryString = queries.join('=');
    } else {
      if (this.queryString.length > 0) {
        this.queryString += '&' + newQuery;
      } else {
        this.queryString += newQuery;
      }
    }
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { query: this.queryString },
      queryParamsHandling: 'merge',
    });
    await this.fetchData({ paginationObject: new PaginationObject(), sortArray: this.sortArray, query: query });
  }

  async removeFromQuery(key) {
    if (this.queryString.includes(key)) {
      var queries = this.queryString.split('&');
      var valueIndex;
      queries.forEach((q, i) => {
        if (q.includes(key)) {
          valueIndex = i;
        }
      });

      queries.splice(valueIndex, 1);
      this.queryString = queries.join('&');
      let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { query: this.queryString },
        queryParamsHandling: 'merge',
      });
      await this.fetchData({ paginationObject: new PaginationObject(), sortArray: this.sortArray, query: query });
    }
  }

  async removeFromSort(key) {
    this.sortArray = this.sortArray.filter((el) => el.prop !== key);
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    await this.fetchData({ paginationObject: new PaginationObject(), sortArray: this.sortArray, query: query });
  }

  inputType(columnName: string) {
    if (this.schema && this.schema[columnName] == 'percentage') {
      return 'number';
    }
    if (this.schema && this.schema[columnName]) {
      return this.schema[columnName];
    } else {
      return 'text';
    }
  }

  clearSearchValue(columnName: string) {
    this.selectedTableColumns.find((el) => el.name == columnName).searchValue = '';
    this.selectedTableColumns = [...this.selectedTableColumns];
    this.search('', columnName);
  }

  async clearSearch() {
    this.queryString = '';
    this.selectedTableColumns.forEach((e) => {
      e.searchValue = null;
    });
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { sort: sortHelper.constructSort(this.sortArray, true).split('sort=')[1], query: this.queryString },
    });
    await this.fetchData({ paginationObject: new PaginationObject(), sortArray: this.sortArray, query: '' });
    this.displaySearch();
  }

  async refreshData() {
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';

    await this.fetchData({ paginationObject: this.paginationObject, sortArray: this.sortArray, query: query });
  }

  addNewColumn(event) {
    this.selectTableColumns(event, true);
  }

  pickCellTemplate(schemaKey: string, columnName: string) {
    switch (columnName) {
      case 'personaName':
      case 'superiorName':
        return this.personNameCell;
      default:
        break;
    }
    if ((this.section === 'order' || this.section === 'budget') && columnName === 'identifier') {
      return this.checkboxCell;
    }
    switch (schemaKey) {
      case 'percentage':
        return this.percentageCell;
      case 'time':
        return this.timeCell;
      case 'date':
        return this.dateCell;
      case 'currency':
        return this.currencyCell;
      case 'text':
      case 'number':
      case 'boolean':
        return this.plainCell;
      case 'dayHourFormat':
        return this.dayHourFormat;
      default:
        if (columnName !== 'identifier')
          console.log('Found ' + columnName + ' which is not in schema. Defaulting to text input.');
        return this.plainCell;
    }
  }

  checkNavigation() {
    if (this.section === 'projects') {
      return this.navigationAndJiraIcon;
    } else if (this.section === 'order-details-project') {
      return this.jiraIcon;
    }
    if (this.section === 'customers') {
      return this.navigationIcon;
    } else if (this.section === 'errors') {
      return this.errorDetails;
    } else {
      return this.navigationIcon;
    }
  }

  onRowSelect(e, row) {
    if (this.selectedRows.find((e) => e === row.identifier)) {
      this.selectedRows = this.selectedRows.filter((e) => e !== row.identifier);
      this.tableData.content.find((el) => {
        if (el.identifier === row.identifier) {
          el.checked = false;
        }
      });
    } else {
      this.selectedRows.push(row.identifier);
      this.tableData.content.find((el) => {
        if (el.identifier === row.identifier) {
          el.checked = true;
        }
      });
    }
  }

  selectAllRows(e) {
    this.checkAll = !this.checkAll;
    if (this.checkAll) {
      this.selectedRows = [];
      this.tableData.content.forEach((row) => {
        row.checked = true;
        this.selectedRows.push(row.identifier);
      });
    } else {
      this.selectedRows = [];
      this.tableData.content.forEach((row) => {
        row.checked = false;
      });
    }
  }

  getDetailsRouteLink(row: any) {
    if (this.section == 'user-management') {
      return 'details/' + row.identifier;
    } else if (this.section == 'order') {
      return '/' + this.section + '/' + row.identifier;
    } else if (this.section == 'projects') {
      return '/project/' + row.identifier;
    } else if (this.section == 'options') {
      return 'option/' + row.identifier;
    } else if (this.section == 'customers') {
      return '/customer/' + row.identifier;
    } else if (this.section == 'errors') {
      return '/errors/' + row.orderCode;
    } else if (this.section == 'budget') {
      return '/order/' + row.orderIdentifier + '/budget/' + row.identifier;
    }
  }

  deleteError(err) {
    this.deleteService(err.identifier).then(() => {
      this.refreshData();
      this.toastService.showSuccess("Operation success!");
    });
  }
}
